<template>
  <div class="custom-select"
        @onmouseenter="openSelector"
        @mouseleave="closeSelector"
  >
    <div class="selected"
          @click="showOptions = !showOptions"
          @onmouseenter="closeSelector"
    >
      <div class="selected-container">
        <div class="selected-content">
          <div class="selected-col">
            <div class="selected-title" v-if="title != null">{{ title }}</div>
            <div class="selected-row">
              <div class="row-icon" v-if="selectedIcon != null"><img :src="selectedIcon" alt=""></div>
              <div class="row-label" :class="{'selected-placeholder': showPlaceholder}">{{ selectedLabel }}</div>
            </div>
          </div>
          <div class="row-r-icon"></div>
        </div>
        <div class="selected-icon" :class="{'selected-row-opened': showOptions}"></div>
      </div>
    </div>
    <div class="items" v-show="showOptions">
      <!-- <div class="placeholder" v-if="placeholder != null">{{ placeholder }}</div> -->
      <div class="row" :class="{'active': index === selectedIndex}" v-for="(option, index) in options"
           v-bind:key="index"
           @click="optionSelected(index)">
        <div class="row-icon" v-if="option.icon != null"><img :src="option.icon" alt=""></div>
        <div class="row-label">{{ option.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */


import {ref, onMounted, watch} from "@vue/runtime-core";
import {computed} from "@vue/reactivity";

export default {
  name: "CustomSelector",
  props: {
    'modelValue': String,
    'title': String,
    'placeholder': String,
    'options': {
      type: Object,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup (props, {emit}) {
    let showPlaceholder = ref(false)
    let showOptions = ref(false)
    let selectedIcon = ref(null)
    let selectedIndex = ref(null)

    const selectedLabel = computed(() => {
      showPlaceholder.value = false
      if (props.placeholder != null) {
        if (selectedIndex.value == null) {
          selectedIcon.value = null
          showPlaceholder.value = true
          return props.placeholder
        }
      }
      if (selectedIndex.value != null) {
        if ('icon' in props.options[selectedIndex.value]) {
          selectedIcon.value = props.options[selectedIndex.value].icon
        } else {
          selectedIcon.value = null
        }
        return props.options[selectedIndex.value].text
      }
      selectedIcon.value = null
      return null
    })

    const refreshValue = (() => {
      // console.log('refreshing...')
      // console.log(props.modelValue)
      //  TODO: avoid it iterating over all the array
      if (props.modelValue != null) {
        props.options.forEach((option, index) => {
          if (option.value === props.modelValue) {
            selectedIndex.value = index
          }
        })
      } else {
        selectedIndex.value = null
      }
      showOptions.value = false
    })

    watch(props.modelValue, () => {
      refreshValue()
    })

    const optionSelected = ((index) => {
      showOptions.value = false
      selectedIndex.value = index
      emit("update:modelValue", props.options[selectedIndex.value].value)
    })

    const openSelector = () => {
      showOptions.value = true
    }

    const closeSelector = () => {
      showOptions.value = false
    }

    onMounted(refreshValue)

    return {
      openSelector,
      closeSelector,

      optionSelected,
      refreshValue,
      selectedLabel,

      showPlaceholder,
      showOptions,
      selectedIcon,
      selectedIndex,
    }
  },
}
</script>
